import * as TabsPrimitive from "@radix-ui/react-tabs";
import { Separator } from "../separator";
import clsx from "clsx";

interface TabsProps {
  children?: React.ReactNode;
  defaultValue: string;
}

const Tabs = (props: TabsProps): JSX.Element => {
  return (
    <TabsPrimitive.Tabs
      className="flex flex-col sm:flex-row gap-5 sm:gap-16 px-6 my-[34px]"
      defaultValue={props.defaultValue}
    >
      {props.children}
    </TabsPrimitive.Tabs>
  );
};

interface TabsListProps {
  children?: React.ReactNode;
}

Tabs.List = (props: TabsListProps): JSX.Element => {
  return (
    <TabsPrimitive.TabsList className="w-[140px] flex flex-col justify-start items-start font-semibold">
      {props.children}
    </TabsPrimitive.TabsList>
  );
};

interface TabsTabsTriggerProps {
  children?: React.ReactNode;
  value: string;
  isActive?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
}
Tabs.TabsTrigger = ({
  children,
  value,
  isActive = false,
  onClick,
}: TabsTabsTriggerProps): JSX.Element => {
  return (
    <TabsPrimitive.TabsTrigger
      value={value}
      className={clsx(
        "py-[10px] text-left hover:bg-grey-600 rounded flex px-[5px]",
        isActive ? "text-primary font-bold" : "text-grey-400 font-normal"
      )}
      onClick={onClick}
    >
      {children}
    </TabsPrimitive.TabsTrigger>
  );
};

interface TabsBodyProps {
  children: React.ReactNode;
}

Tabs.Body = (props: TabsBodyProps): JSX.Element => {
  return (
    <div className="w-full rounded-[16px] border border-gray-200 pt-[20px] pb-[40px] px-[40px]">
      {props.children}
    </div>
  );
};

interface TabsContentProps {
  title: string;
  value: string;
  children?: React.ReactNode;
}

Tabs.Content = (props: TabsContentProps): JSX.Element => {
  return (
    <TabsPrimitive.TabsContent className="w-full" value={props.value}>
      <h1 className="text-2xl font-semibold">{props.title}</h1>
      <Separator className="my-5" />
      {props.children}
    </TabsPrimitive.TabsContent>
  );
};

export default Tabs;
